import { SolitaireGame } from "game/SolitaireGame";
import { Store } from "game/store/gameStore";

export class TimerLocalStorageUpdater {
    private prevTimer: string;

    constructor (game: SolitaireGame) {
        this.prevTimer = "";

        setInterval(() => {
            if (Store.gameActive && this.prevTimer !== Store.getTimeFormat(Store.time)) {
                this.prevTimer = Store.getTimeFormat(Store.time)

                Store.setGameState(game);
            }
        }, 5000);
    }
}